import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { shareReplay, switchMap, tap, map, withLatestFrom } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Race } from '../../race';
import { Driver } from '../../../../gepard/drivers/driver';
import { Result } from '../../../results/result/result';
import { RacesService } from '../../../races/races.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'mc-start-start-number-change-tool',
  templateUrl: './start-number-change-tool.component.html',
  styleUrls: ['./start-number-change-tool.component.scss']
})
export class StartNumberChangeToolComponent implements OnInit {

  canCommand: boolean = environment.isAdmin;

  race$: Observable<Race> = this.activatedRoute.parent.parent.data.pipe(
    switchMap((data) => data.race$ as Observable<Race>),
    shareReplay({
      refCount: true,
      bufferSize: 1
    })
  );

  sourceDriverId$: BehaviorSubject<Driver['startNumber'] | null> = new BehaviorSubject<Driver['startNumber'] | null>(null);

  isLoaded: boolean = null;

  laps$: Observable<Result[]> = combineLatest([
    this.race$,
    this.sourceDriverId$
  ]).pipe(
    tap(() => {
      this.isLoaded = false;
    }),
    switchMap(([race, sourceDriverId]) => race.results$.pipe(
      map((results) => {
        return results.filter(result => {
          return result.driverId === sourceDriverId;
        });
      }),
      tap(() => {
        this.isLoaded = true;
      })
    )),
  );

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly racesService: RacesService
  ) { }

  ngOnInit(): void {
  }

  listLaps(driverId: number) {
    this.sourceDriverId$.next(driverId);
  }

  moveResultsToDriver(results: Result[], driverId: number) {
    this.isLoaded = false;

    return this.race$.pipe(
      switchMap(race => race.syncedStorage.db$),
      switchMap((db) => {
        let bulkUpdated = results.map(result => ({
          ...result,
          driverId: driverId
        }));
        return db.bulkDocs(bulkUpdated);
      }),
      withLatestFrom(this.sourceDriverId$),
      tap(([response, sourceDriverId]) => {
        console.log(response, sourceDriverId);
        this.isLoaded = true;
        this.listLaps(sourceDriverId);
      }),
    ).subscribe();
  }
}
